module.exports = __webpack_public_path__ + "img/印刷电路板(PCB)行业结构示意图.4d678746.jpg";